// extracted by mini-css-extract-plugin
export default {"spin":"CustomSpin_spin__SSzmm"};